var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-header',{attrs:{"title":_vm.title}}),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("./goods-merchandise1.jpg"),"alt":""}}),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("./goods-merchandise2.jpg"),"alt":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }